/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Button, Modal, Spinner, Form } from "react-bootstrap";

export default function DeleteWorkflowFormModal(props) {
  const [deleteConfirmText, setDeleteConfirmText] = useState();
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable
      title=""
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.title}
        </Modal.Title>
      </Modal.Header>
      {props.custombody}
      {!props.custombody && props.body && (
        <>
          <Modal.Body>
            {props.custombody || props.body}
            {
              <Form.Group as={Row} controlId="deleteConfirmTextGroup">
                <Col>
                  <Form.Label><small>{`To confirm deletion, type DELETE in the text input field.`}</small></Form.Label>
                  <Form.Control
                    required
                    maxLength="250"
                    type="input"
                    name="deleteConfirmTextInput"
                    onChange={(e) => setDeleteConfirmText(e.target.value)}
                    placeholder='DELETE'
                  />
                  <Form.Control.Feedback type="invalid">
                  This field is required
                  </Form.Control.Feedback>
                </Col>
              </Form.Group>
            }
          </Modal.Body>
          <Modal.Footer>
            {!props.showspinner ? (
              props.customfooter ? (
                props.customfooter
              ) : (
                <div style={{ width: "100%", display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
                  <Button
                    style={{ marginRight: '10px' }}
                    onClick={(e) => {
                      setDeleteConfirmText(null);
                      props.onHide(e, false);
                    }}
                    variant="outline-secondary"
                  >
                    Cancel
                  </Button>
                  <Button
                    disabled={deleteConfirmText !== "DELETE"}
                    onClick={(e) => props.onHide(e, true)}
                    variant="outline-primary"
                  >
                    {props.confirmtext}
                  </Button>
                </div>
              )
            ) : (
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            )}
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
}
